import { useMemo } from "react";

import { useConfig } from "@jti/app-context/useConfig";

const DEFAULT_EMAIL_PATTERN = /^[A-Z0-9._'%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const useEmailPattern = (): RegExp => {
  const { EMAIL_PATTERN } = useConfig();

  return useMemo(() => {
    if (EMAIL_PATTERN) {
      try {
        return new RegExp(EMAIL_PATTERN, "i");
      } catch {
        return DEFAULT_EMAIL_PATTERN;
      }
    }

    return DEFAULT_EMAIL_PATTERN;
  }, [EMAIL_PATTERN]);
};
